import React, { Component } from "react";
import {
  Alert,
  Checkbox,
  Col,
  Collapse,
  Empty,
  Input,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Typography,
  message,
} from "antd";
import { DownloadOutlined, FilePdfOutlined, FileExcelOutlined } from "@ant-design/icons";
import axios from "axios";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import {
  ButtonItem,
  DatePickerItem,
  ModalItem,
  TextAreaItem,
} from "../../../../Components/Items";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
import solicitudCotizacionPdf from "../../../../Pdf/solicitudCotizacionPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text } = Typography;
const { Panel } = Collapse;

const SIN_FAMILIA = "__sin_familia__";

class SolicitarCotizacion extends Component {
  state = {
    seleccionados: [],
    familiaId: null,
    busqueda: "",
    proveedoresIds: [],
    sinProveedor: false,
    vigencia: null,
    observaciones: "",
    generando: false,
    modalPdf: false,
    // null = todas las familias abiertas. Cuando el usuario abre o cierra alguna,
    // pasa a ser el arreglo de las que quedaron abiertas.
    gruposAbiertos: null,
  };

  componentDidMount() {
    this.seleccionarTodos();
    this.setState({ proveedoresIds: this.props.proveedoresSugeridos.map((p) => p._id) });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.insumos !== this.props.insumos) this.seleccionarTodos();
  }

  seleccionarTodos = () => {
    this.setState({
      seleccionados: (this.props.insumos || []).map((valueInsumo) =>
        valueInsumo.insumoId.toString()
      ),
    });
  };

  // Familias que realmente aparecen en la requisicion: el universo es la requisicion,
  // por eso no hace falta consultar el catalogo completo de familias.
  get familias() {
    const mapa = new Map();
    (this.props.insumos || []).forEach((valueInsumo) => {
      if (valueInsumo.familiaId && !mapa.has(valueInsumo.familiaId.toString())) {
        mapa.set(valueInsumo.familiaId.toString(), valueInsumo.familia || "Sin nombre");
      }
    });
    return [...mapa.entries()].map(([id, nombre]) => ({ id, nombre }));
  }

  // El filtro solo cambia lo que se ve; la seleccion se conserva aunque se filtre
  get insumosFiltrados() {
    const { familiaId, busqueda } = this.state;
    const texto = busqueda.trim().toLowerCase();

    return (this.props.insumos || []).filter((valueInsumo) => {
      if (familiaId && valueInsumo.familiaId?.toString() !== familiaId) return false;
      if (!texto) return true;
      return (
        String(valueInsumo.claveInt || "").toLowerCase().includes(texto) ||
        String(valueInsumo.descripcion || "").toLowerCase().includes(texto)
      );
    });
  }

  get insumosSeleccionados() {
    const seleccion = new Set(this.state.seleccionados);
    return (this.props.insumos || []).filter((valueInsumo) =>
      seleccion.has(valueInsumo.insumoId.toString())
    );
  }

  // Los insumos visibles, partidos por familia y ordenados alfabeticamente.
  // "Sin familia" siempre va al final para que no se cuele entre las reales.
  get gruposPorFamilia() {
    const grupos = new Map();

    this.insumosFiltrados.forEach((valueInsumo) => {
      const id = valueInsumo.familiaId
        ? valueInsumo.familiaId.toString()
        : SIN_FAMILIA;
      if (!grupos.has(id)) {
        grupos.set(id, {
          id,
          nombre: valueInsumo.familia || "Sin familia",
          insumos: [],
        });
      }
      grupos.get(id).insumos.push(valueInsumo);
    });

    return [...grupos.values()].sort((a, b) => {
      if (a.id === SIN_FAMILIA) return 1;
      if (b.id === SIN_FAMILIA) return -1;
      return a.nombre.localeCompare(b.nombre, "es");
    });
  }

  seleccionarFiltrados = () => {
    const visibles = this.insumosFiltrados.map((valueInsumo) =>
      valueInsumo.insumoId.toString()
    );
    this.setState({ seleccionados: visibles });
  };

  /**
   * Cada familia tiene su propia tabla, asi que su rowSelection solo conoce sus
   * renglones visibles: se conserva todo lo palomeado fuera de ese grupo (otras
   * familias, y lo que el buscador dejo fuera) y se reemplaza solo su parte.
   */
  cambiarSeleccionGrupo = (grupo, llavesDelGrupo) => {
    const llavesVisibles = new Set(
      grupo.insumos.map((valueInsumo) => valueInsumo.insumoId.toString())
    );
    this.setState((prevState) => ({
      seleccionados: [
        ...prevState.seleccionados.filter((llave) => !llavesVisibles.has(llave)),
        ...llavesDelGrupo,
      ],
    }));
  };

  alternarGrupoCompleto = (grupo, marcar) => {
    this.setState((prevState) => {
      const seleccion = new Set(prevState.seleccionados);
      grupo.insumos.forEach((valueInsumo) => {
        const llave = valueInsumo.insumoId.toString();
        if (marcar) seleccion.add(llave);
        else seleccion.delete(llave);
      });
      return { seleccionados: [...seleccion] };
    });
  };

  alternarTodosLosGrupos = (grupos, abrir) => {
    this.setState({ gruposAbiertos: abrir ? grupos.map((g) => g.id) : [] });
  };

  construirDatosPdf = (proveedor, cotizacion) => ({
    data: cotizacion || {},
    requisicion: {
      numero: this.props.requisicion.numero,
      fechaEntrega: this.props.requisicion.fechaEntrega,
      createdAt: this.props.requisicion.createdAt,
    },
    proveedor: proveedor || null,
    insumos: this.insumosSeleccionados,
    empresa: this.props.empresa,
    logoBiwo: this.props.logoBiwo,
    usuario: this.props.usuario,
    proyecto: this.props.proyecto,
    vigencia: this.state.vigencia ? this.state.vigencia.toISOString() : null,
    observaciones: this.state.observaciones,
  });

  verPdfEnBlanco = () => {
    if (this.insumosSeleccionados.length === 0) {
      message.error("Seleccione al menos un insumo");
      return;
    }
    this.setState({ modalPdf: true }, () => {
      const pdf = pdfMake.createPdf(solicitudCotizacionPdf(this.construirDatosPdf(null)));
      pdf.open({}, window.frames["solicitudCotizacionPdf"]);
    });
  };

  descargarPdfEnBlanco = () => {
    pdfMake
      .createPdf(solicitudCotizacionPdf(this.construirDatosPdf(null)))
      .download(`SolicitudCotizacion_Req${this.props.requisicion.numero}.pdf`);
  };

  /**
   * Plantilla que el proveedor llena y regresa. Las 4 primeras columnas vienen con los
   * datos de la requisicion; las demas en blanco. Es la misma plantilla que lee
   * ModalCargarCotizacion, por eso los encabezados no deben cambiarse por separado.
   */
  descargarPlantilla = () => {
    const insumos = this.insumosSeleccionados;
    if (insumos.length === 0) {
      message.error("Seleccione al menos un insumo");
      return;
    }

    const filas = insumos.map((valueInsumo) => ({
      Clave: valueInsumo.claveInt || "",
      Descripcion: valueInsumo.descripcion || "",
      Unidad: valueInsumo.unidad || "",
      Cantidad: valueInsumo.cantidad,
      "Codigo Proveedor": "",
      "Descripcion Proveedor": "",
      "Precio Unitario": "",
      "Compra Minima": "",
      "Tiempo Entrega": "",
      Observaciones: "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(filas);
    worksheet["!cols"] = [
      { wch: 14 }, { wch: 45 }, { wch: 10 }, { wch: 10 }, { wch: 18 },
      { wch: 45 }, { wch: 15 }, { wch: 14 }, { wch: 16 }, { wch: 30 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Cotizacion");
    XLSX.writeFile(
      workbook,
      `PlantillaCotizacion_Req${this.props.requisicion.numero}.xlsx`
    );
  };

  generarSolicitudes = async () => {
    const insumos = this.insumosSeleccionados;
    if (insumos.length === 0) {
      message.error("Seleccione al menos un insumo");
      return;
    }
    if (this.state.proveedoresIds.length === 0) {
      message.error("Seleccione al menos un proveedor");
      return;
    }

    this.setState({ generando: true });
    try {
      const res = await axios.post(
        "cotizacionesRequisicion/generarSolicitudes",
        {
          empresaId: this.props.empresaId,
          requisicionId: this.props.requisicion._id,
          proveedoresIds: this.state.proveedoresIds,
          insumosSeleccionados: insumos.map((valueInsumo) => valueInsumo.insumoId),
          vigencia: this.state.vigencia ? this.state.vigencia.toISOString() : null,
          observaciones: this.state.observaciones,
        },
        { headers: this.props.headersToken }
      );

      this.setState({ generando: false });

      if (res.data.success !== 2) {
        message.error(res.data.message || "No se pudieron generar las solicitudes");
        return;
      }

      message.success(`${res.data.solicitudes.length} solicitud(es) generada(s)`);
      this.props.onSolicitudesGeneradas(res.data.comun, res.data.solicitudes);
    } catch (err) {
      console.error(err);
      this.setState({ generando: false });
      message.error("Sucedió un error y no se pudieron generar las solicitudes");
    }
  };

  render() {
    const { seleccionados, familiaId, busqueda, sinProveedor, generando } = this.state;
    const familias = this.familias;
    const filtrados = this.insumosFiltrados;
    const grupos = this.gruposPorFamilia;
    const seleccionActual = new Set(seleccionados);

    // null = nunca se ha tocado el collapse, asi que todas las familias van abiertas
    const gruposAbiertos =
      this.state.gruposAbiertos === null
        ? grupos.map((valueGrupo) => valueGrupo.id)
        : this.state.gruposAbiertos;
    const hayAlgunoAbierto = gruposAbiertos.length > 0;

    // La familia ya es el encabezado del grupo: repetirla en cada renglon sobra
    const columnas = [
      { title: "Clave", dataIndex: "claveInt", width: 120 },
      { title: "Descripción", dataIndex: "descripcion" },
      { title: "Unidad", dataIndex: "unidad", width: 90 },
      { title: "Cantidad", dataIndex: "cantidad", width: 100, align: "right" },
      {
        title: "Pendiente",
        width: 100,
        align: "right",
        render: (_, valueInsumo) =>
          Math.max((valueInsumo.cantidad || 0) - (valueInsumo.cantidadOrdenada || 0), 0),
      },
    ];

    return (
      <div>
        <Row gutter={[16, 8]} style={{ marginBottom: 12 }}>
          <Col xs={24} md={6}>
            <Text strong>Familia</Text>
            <Select
              style={{ width: "100%" }}
              placeholder="Todas las familias"
              allowClear
              value={familiaId}
              onChange={(valor) => this.setState({ familiaId: valor || null })}
            >
              {familias.map((valueFamilia) => (
                <Select.Option key={valueFamilia.id} value={valueFamilia.id}>
                  {valueFamilia.nombre}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} md={6}>
            <Text strong>Buscar</Text>
            <Input.Search
              placeholder="Clave o descripción"
              allowClear
              value={busqueda}
              onChange={(e) => this.setState({ busqueda: e.target.value })}
            />
          </Col>
          <Col xs={24} md={5}>
            <Text strong>Responder antes de</Text>
            <DatePickerItem
              style={{ width: "100%" }}
              value={this.state.vigencia}
              onChange={(fecha) => this.setState({ vigencia: fecha })}
              placeholder="Opcional"
            />
          </Col>
          <Col xs={24} md={7}>
            <Text strong>Observaciones</Text>
            <TextAreaItem
              rows={1}
              value={this.state.observaciones}
              onChange={(e) => this.setState({ observaciones: e.target.value })}
              placeholder="Texto que verá el proveedor"
            />
          </Col>
        </Row>

        <div style={{ marginBottom: 8, display: "flex", flexWrap: "wrap", alignItems: "center" }}>
          <Space wrap>
            <Text type="secondary">
              {seleccionados.length} de {(this.props.insumos || []).length} insumo(s)
              seleccionado(s)
            </Text>
            <ButtonItem type="link" onClick={this.seleccionarFiltrados}>
              Seleccionar solo lo filtrado ({filtrados.length})
            </ButtonItem>
            <ButtonItem type="link" onClick={this.seleccionarTodos}>
              Seleccionar todo
            </ButtonItem>
            {grupos.length > 1 && (
              <ButtonItem
                type="link"
                onClick={() => this.alternarTodosLosGrupos(grupos, !hayAlgunoAbierto)}
              >
                {hayAlgunoAbierto ? "Contraer familias" : "Expandir familias"}
              </ButtonItem>
            )}
          </Space>
        </div>

        {grupos.length === 0 ? (
          <Empty description="Ningún insumo coincide con el filtro" />
        ) : (
          <Collapse
            activeKey={gruposAbiertos}
            onChange={(llaves) =>
              this.setState({
                gruposAbiertos: Array.isArray(llaves) ? llaves : [llaves],
              })
            }
          >
            {grupos.map((valueGrupo) => {
              const llavesGrupo = valueGrupo.insumos.map((valueInsumo) =>
                valueInsumo.insumoId.toString()
              );
              const seleccionadasGrupo = llavesGrupo.filter((llave) =>
                seleccionActual.has(llave)
              );
              const todas = seleccionadasGrupo.length === llavesGrupo.length;
              const algunas = seleccionadasGrupo.length > 0 && !todas;

              return (
                <Panel
                  key={valueGrupo.id}
                  header={
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <Checkbox
                        checked={todas}
                        indeterminate={algunas}
                        // Sin esto, palomear la familia tambien abre o cierra el panel
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) =>
                          this.alternarGrupoCompleto(valueGrupo, e.target.checked)
                        }
                      />
                      <Text strong>{valueGrupo.nombre}</Text>
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        {seleccionadasGrupo.length} de {llavesGrupo.length}
                      </Text>
                    </div>
                  }
                >
                  <Table
                    size="small"
                    rowKey={(valueInsumo) => valueInsumo.insumoId.toString()}
                    columns={columnas}
                    dataSource={valueGrupo.insumos}
                    pagination={false}
                    rowSelection={{
                      selectedRowKeys: seleccionadasGrupo,
                      onChange: (llaves) =>
                        this.cambiarSeleccionGrupo(valueGrupo, llaves),
                    }}
                  />
                </Panel>
              );
            })}
          </Collapse>
        )}

        <Row gutter={[16, 8]} style={{ marginTop: 16 }} align="bottom">
          <Col xs={24} md={14}>
            <Text strong>Proveedores</Text>
            <div>
              <SelectProveedoresItem
                mode="multiple"
                style={{ width: "100%" }}
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                disabled={sinProveedor}
                value={this.state.proveedoresIds}
                onChange={(valor) => this.setState({ proveedoresIds: valor || [] })}
                placeholder="Seleccione uno o varios proveedores"
              />
            </div>
          </Col>
          <Col xs={24} md={10}>
            <Space>
              <Switch
                checked={sinProveedor}
                onChange={(valor) => this.setState({ sinProveedor: valor })}
              />
              <Text>Sin proveedor (documento en blanco)</Text>
            </Space>
          </Col>
        </Row>

        {sinProveedor && (
          <Alert
            type="info"
            showIcon
            style={{ marginTop: 10 }}
            message="El documento en blanco solo se imprime: no se guarda ninguna solicitud ni se manda correo."
          />
        )}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
          <ButtonItem icon={<FilePdfOutlined />} onClick={this.verPdfEnBlanco}>
            Ver PDF en blanco
          </ButtonItem>
          <ButtonItem icon={<FileExcelOutlined />} onClick={this.descargarPlantilla}>
            Descargar Plantilla Excel
          </ButtonItem>
          <ButtonItem
            type="primary"
            loading={generando}
            disabled={sinProveedor}
            onClick={this.generarSolicitudes}
          >
            Generar Solicitudes
          </ButtonItem>
        </div>

        <ModalItem
          title="Solicitud de Cotización"
          visible={this.state.modalPdf}
          onCancel={() => this.setState({ modalPdf: false })}
          paddingTop
        >
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
            <ButtonItem
              type="primary"
              icon={<DownloadOutlined />}
              onClick={this.descargarPdfEnBlanco}
            >
              Descargar
            </ButtonItem>
          </div>
          <iframe
            title="Solicitud de Cotización"
            style={{ width: "100%", height: "100vh" }}
            id="solicitudCotizacionPdf"
            name="solicitudCotizacionPdf"
          />
        </ModalItem>
      </div>
    );
  }
}

export default SolicitarCotizacion;
